import React, { Component } from 'react'
import classnames from 'classnames'
import Icon from 'svg-inline-react'

import compose from 'recompose/compose'
import withOrgTeams from 'app/modules/teams/hoc/withOrgTeams'

import TooltipAvatar from 'components/TooltipAvatar'

const personIcon = require('!svg-inline?removeTags=true!images/svg/participant.svg')
const arrowIcon = require('!svg-inline?removeTags=true!images/svg/marker.svg')

const types = {
  PARTICIPANT: <div className="participant-add-heading"><Icon src={personIcon} /> Add Participant</div>,
  SALESFORCE_PARTICIPANT: <div className="participant-add-heading"><Icon src={personIcon} /> Add Participant</div>,
  ABM_PARTICIPANT: <div className="participant-add-heading"><Icon src={personIcon} /> Add Drift Account Owner</div>,
  LEANDATA_PARTICIPANT: <div className="participant-add-heading"><Icon src={personIcon} /> Add LeanData Account Owner</div>,
}

class RuleActions extends Component {

  displayType(type) {
    return types[type]
  }

  subTypes = () => {
    return {
      PARTICIPANT: this.renderActionSet,
      SALESFORCE_PARTICIPANT: this.salesforceSubType,
      ABM_PARTICIPANT: this.targetedAccountsSubType,
      LEANDATA_PARTICIPANT: this.leandataSubType,
    }
  }

  renderUsers() {
    const { action, users } = this.props
    return (
      action.options.userIds.map((userId, index)=> {
        const user = users[userId]
        if (user) {
          return (
            <div key={index} className="participant-avatar">
              <TooltipAvatar tooltipName={user.name} type="user" user={user}/>
            </div>
          )
        }
      })
    )
  }

  renderTeam = () => {
    const { action, teams } = this.props

    if (action.options.teamId) {
      const team = teams.find(x => x.id === action.options.teamId)
      if (team) {
        return (
          <div className="participant-avatar">
            <TooltipAvatar tooltipName={team.name} type="team" team={team}/>
          </div>
        )
      }
    }
  }

  renderLink = () => {
    const isActive = this.props.activePage === "actionEditor"
    const activeClass = isActive ? 'active' : ''
    return (
      <ul>
        <li>{ this.displayType(this.props.action.type) }</li>
        <li className={`${ activeClass} action-preview-link`}>
          { isActive && <Icon src={arrowIcon} />}
          Choose Action
        </li>
      </ul>
    )
  }

  renderActionSet = () => {
    const { action } = this.props
    const hasUserIds = !!action.options.userIds && action.options.userIds.length > 0
    const isActive = this.props.activePage === "actionEditor"
    const activeClass = isActive ? 'active' : ''
    const hasNoParticipants = !hasUserIds && !action.options.teamId
    return (
      <ul>
        <li>{ this.displayType(this.props.action.type) }</li>
        <li className={`${ activeClass} action-preview-users`}>
          { isActive && <Icon src={arrowIcon} />}
          <div className="action-participant-container">
            { hasNoParticipants && <span className="action-preview-link">Choose Participants</span>}
            { !hasUserIds && this.renderTeam() }
            { hasUserIds && this.renderUsers() }
          </div>
        </li>
      </ul>
    )
  }

  salesforceSubType = () => {
    const isActive = this.props.activePage === "actionEditor"

    return (
      <ul>
        <li>{ this.displayType(this.props.action.type) }</li>
        <li className={classnames('action-preview-users', { isActive: 'active' })}>
          { isActive && <Icon src={arrowIcon} />}
          <span>Account/Contact/Lead Owners</span>
        </li>
      </ul>
    )
  }

  targetedAccountsSubType = () => {
    const isActive = this.props.activePage === "actionEditor"

    return (
      <ul>
        <li>{ this.displayType(this.props.action.type) }</li>
        <li className={classnames('action-preview-users', { isActive: 'active' })}>
          { isActive && <Icon src={arrowIcon} />}
          <span>Drift Account Owners</span>
        </li>
      </ul>
    )
  }

  leandataSubType = () => {
    const isActive = this.props.activePage === "actionEditor"

    return (
      <ul>
        <li>{ this.displayType(this.props.action.type) }</li>
        <li className={classnames('action-preview-users', { isActive: 'active' })}>
          { isActive && <Icon src={arrowIcon} />}
          <span>LeanData Account Owners</span>
        </li>
      </ul>
    )
  }

  actionOrLink() {
    if (_.isEmpty(this.props.action)) {return this.renderLink()}

    return this.subTypes()[this.props.action.type]()
  }

  render() {
    const { noFilters } = this.props

    return (
      <div className="rule-actions overview-rule" onClick={() => this.props.setActivePage('actionEditor')}>
        <h3>{noFilters ? `Add one of the following:` : `Then do this...`}</h3>
        { this.actionOrLink() }
      </div>
    )
  }
}

export default compose(withOrgTeams)(RuleActions)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/RulesEditorOverview/RuleActions.js